import { createHistogramFormReducer } from '@/features/histogram-form/model/slice/create-histogram-form.slice';
import { ReducerList } from '@/shared/lib/components/lazy-reducer/lazy-reducer.types';

export const reducers: ReducerList = {
	createHistogramForm: createHistogramFormReducer,
};
